import { Fragment , useEffect , useState } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Navigate } from 'react-router-dom'
const navigation = [
    { name: 'Home', current: true, path: '/' },
    { name: "Leaderboard", current: false, path: "/leaderboard" },
    { name: 'About us', current: false, path: '/about' },
    { name: 'Contact us', current: false, path: '/contact' },
    { name: 'My Profile', current: false, path: '/profile' },
]


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
    const [selectedItems, setSelectedItems] = useState('');
    // console.log("Selected Items ", selectedItems);
    const navigate = useNavigate();
    const logoutUser = () => {
        Cookies.remove('userId')
        Cookies.remove('accessToken')
    }
    function useScreenWidth() {
        const [screenWidth, setScreenWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => {
                setScreenWidth(window.innerWidth);
            };

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);

        return screenWidth;
    }
    const screenWidth = useScreenWidth();
    const isMobileScreen = screenWidth <= 640;

    return (
        <Disclosure as="nav" className="bg-gray-800">
            {({ open }) => (
                <>
                    {isMobileScreen && (
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                            <div className="relative flex h-16 items-center justify-between">
                                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                    {/* Mobile menu button*/}
                                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Open main menu</span>
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    </Disclosure.Button>
                                </div>
                                {/* Rest of the navigation code */}
                            </div>
                        </div>
                    )}
                    <div className="flex flex-1 items-center justify-end sm:items-stretch sm:justify-end lg:p-3">
                        <div className="hidden sm:ml-6 sm:block">
                            <div className="flex space-x-4">
                                {navigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        className={classNames(
                                            'text-gray-300 hover:bg-gray-700 hover:text-white',
                                            'rounded-md px-3 py-2 text-sm font-medium'
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                        to={item.path}
                                    // onClick={() => setSelectedItems(item.name)}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                                <Link
                                    className={classNames(
                                        'text-gray-300 hover:bg-gray-700 hover:text-white',
                                        'rounded-md px-3 py-2 text-sm font-medium'
                                    )}
                                    to="/login"
                                    onClick={logoutUser}
                                >
                                    Logout
                                </Link>
                            </div>
                        </div>
                    </div>
                    {/* <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                            </div> */}

                    {/* Mobile menu */}
                    <Disclosure.Panel className="sm:hidden">
                        <div className="space-y-1 px-2 pb-3 pt-2">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.path}
                                    className={classNames(
                                        'block rounded-md px-3 py-2 text-base font-medium',
                                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                                    )}
                                    aria-current={item.current ? 'page' : undefined}
                                >
                                    {item.name}
                                </Link>
                            ))}
                            {/* Logout link */}
                            <Link
                                to="/login"
                                onClick={logoutUser}
                                className="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
                            >
                                Logout
                            </Link>
                        </div>
                    </Disclosure.Panel>
                </>
            )
            }
        </Disclosure >
    )
}
